<template>
  <b-modal
    :id="id"
    :title="clone ? 'Clone Major Version' : 'Create New Major Version'"
    lazy
    hide-footer
    @shown="$refs.newConfigValue.focus()">
    <b-form
      inline
      @submit="onSubmit"
      @reset="onReset">
      <label
        v-if="clone"
        for="existingVersions">
        Clone From:
      </label>
      <b-form-select
        v-if="clone"
        id="existingVersions"
        v-model="selectedConfig"
        class="mx-2"
        :options="majorConfigOptions"
        required />
      <label
        class="sr-only"
        for="newConfigValue">
        Name
      </label>
      <b-form-input
        id="newConfigValue"
        ref="newConfigValue"
        v-model.number="newConfig"
        type="number"
        placeholder="New Major Version"
        required />
      <div
        slot="modal-footer"
        class="mt-2 w-100">
        <b-btn
          type="submit"
          variant="primary"
          class="ml-2 float-right">
          {{ clone ? 'Clone' : 'Create' }}
        </b-btn>
        <b-btn
          type="reset"
          variant="secondary"
          class="float-right">
          Cancel
        </b-btn>
      </div>
    </b-form>
  </b-modal>
</template>

<script>

  import { Config } from '@/services/api'

  export default {
    name: "NewMajorConfigModal",
    props: {
      id: {
        type: String,
        required: true,
      },
      platformId: {
        type: Number,
        required: false,
        default: null,
      },
      clone: {
        type: Boolean,
        default: false,
      },
      configs: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        majorConfigOptions: [],
        selectedConfig: null,
        newConfig: null,
      }
    },
    watch: {
      configs(newVal) {
        this.majorConfigOptions = newVal.map(c => {
          return {
            text: c.version,
            value: c.version,
          }
        })
        this.selectedConfig = this.majorConfigOptions.map(r => r.value)[this.majorConfigOptions.length - 1]
      },
    },
    methods: {
      onReset() {
        this.selectedConfig = null
        this.newConfig = null
        this.$root.$emit('bv::hide::modal', this.id)
      },
      async onSubmit(evt) {
        evt.preventDefault()
        let majorID
        if (this.clone) {
          majorID = await Config.cloneMajor(this.platformId, this.selectedConfig, this.newConfig)
        } else {
          majorID = await Config.createMajor(this.platformId, this.newConfig)
        }
        this.$router.push({ path: '/', query: { platformId: this.platformId.toString(), majorId: majorID.toString() } })
        this.onReset()
      },
    },
  }
</script>

<style scoped>

</style>